import { Stack, Tab, Tabs, Typography } from '@mui/material'
import { Outlet, NavLink, useLocation } from 'react-router-dom'
import { TabsStyle } from '../../../components/ProjectPage/ProjectTabs/style'
import type { ITeamViewerPermissions } from '../../../api/types/teams'

function buildTabIndex(permissions?: ITeamViewerPermissions): Record<string, number> {
  let index = 0
  const map: Record<string, number> = {}
  if (permissions?.can_edit_content) {
    map.profile = index++
  }
  if (permissions?.can_manage_team) {
    map.members = index++
  }
  if (permissions?.can_manage_admins) {
    map.administration = index++
  }
  return map
}

export const EditTeamTabs = ({
  title,
  permissions,
}: {
  title: string
  permissions?: ITeamViewerPermissions
}) => {
  const location = useLocation()
  const tabIndex = buildTabIndex(permissions)

  const currentTab = location.pathname.includes('administration')
    ? tabIndex.administration ?? 0
    : location.pathname.includes('members')
    ? tabIndex.members ?? 0
    : tabIndex.profile ?? 0

  const showProfile = permissions?.can_edit_content === true
  const showMembers = permissions?.can_manage_team === true
  const showAdministration = permissions?.can_manage_admins === true

  return (
    <Stack alignItems="center" pt={{ xs: '15px', md: '50px' }} height="100%" px={1.5}>
      <Stack gap={2} maxWidth={{ xs: '736px', md: '840px' }} width="100%" height="100%">
        <Typography variant="h1" px={{ xs: 0, md: 2.5 }}>
          {title}
        </Typography>
        <Tabs
          value={currentTab}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={TabsStyle}
        >
          {showProfile && <Tab label="Профиль" component={NavLink} to="" />}
          {showMembers && <Tab label="Участники" component={NavLink} to="members" />}
          {showAdministration && <Tab label="Администрирование" component={NavLink} to="administration" />}
        </Tabs>
        <Outlet />
      </Stack>
    </Stack>
  )
}
